/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logo-tva': {
    width: 16,
    height: 12,
    viewBox: '0 0 16 12',
    data: '<path pid="0" d="M4.402 0l.012 12h-.862V.945H0V0h4.402zM5 0h2.739l3.992 12H8.992L5 0zM12.001 0h-.935l3.992 12H16L12 0z" _fill="#fff"/>'
  }
})
